// extracted by mini-css-extract-plugin
export default {"main":"page404_main__Sq4u1","container":"page404_container__3ua3e","title":"page404_title__mcS4b","message":"page404_message__83s1t","button":"page404_button__azdks"};